export enum customerViewType {
  SEARCH_CUSTOMER_VIEW = 'SEARCH_CUSTOMER_VIEW',
  DISPLAY_EXISTING_CUSTOMER_VIEW = 'DISPLAY_EXISTING_CUSTOMER_VIEW',
  NEW_CUSTOMER_VIEW = 'NEW_CUSTOMER_VIEW',
}